import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'reviews',
    lazy: async () => ({ Component: (await import('./ReviewsPage')).ReviewsPage }),
  },
];
